module.exports = __webpack_public_path__ + "static/media/BR-2022-065.e7578085.pdf";